import React from 'react';
import PropTypes from 'prop-types';

const Pan = ({ fill, theme, width = '20', height = '22', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.1003 5.13208H1.10032L1.10029 5.13048C1.09609 4.86688 1.13748 4.60512 1.22188 4.36027C1.30629 4.11543 1.43191 3.89271 1.59102 3.70458C1.75012 3.51647 1.93944 3.36678 2.14776 3.26334C2.35572 3.16008 2.57886 3.10475 2.80459 3.1H17.1954C17.4211 3.10475 17.6443 3.16008 17.8522 3.26334C18.0606 3.36678 18.2499 3.51647 18.409 3.70458C18.5681 3.89271 18.6937 4.11543 18.7781 4.36027C18.8625 4.60512 18.9039 4.86688 18.8997 5.13048V5.13208L18.8997 16.8679L18.8997 16.8695C18.9039 17.1331 18.8625 17.3949 18.7781 17.6397C18.6937 17.8846 18.5681 18.1073 18.409 18.2954C18.2499 18.4835 18.0606 18.6332 17.8522 18.7367C17.6443 18.8399 17.4212 18.8953 17.1954 18.9H2.80457C2.57885 18.8953 2.35572 18.8399 2.14776 18.7367C1.93944 18.6332 1.75012 18.4835 1.59102 18.2954C1.43191 18.1073 1.30629 17.8846 1.22188 17.6397C1.13748 17.3949 1.09609 17.1331 1.10029 16.8695L1.1003 16.8695V16.8679V5.13208ZM17.1965 16.9679H17.2965V16.8679V5.13208V5.03208H17.1965H2.80355H2.70355V5.13208V16.8679V16.9679H2.80355H17.1965Z"
      fill="#6B6C7B"
      stroke="white"
      strokeWidth="0.2"
    />
    <path
      d="M5.77634 8.1H8.22366C8.57549 8.1 8.9 8.47627 8.9 8.99526V9.00474C8.9 9.52373 8.57549 9.9 8.22366 9.9H5.77634C5.42451 9.9 5.1 9.52373 5.1 9.00474V8.99526C5.1 8.47627 5.42451 8.1 5.77634 8.1Z"
      fill="#6B6C7B"
      stroke="white"
      strokeWidth="0.2"
    />
    <path
      d="M5.77634 12.1H8.22366C8.57549 12.1 8.9 12.4763 8.9 12.9953V13.0047C8.9 13.5237 8.57549 13.9 8.22366 13.9H5.77634C5.42451 13.9 5.1 13.5237 5.1 13.0047V12.9953C5.1 12.4763 5.42451 12.1 5.77634 12.1Z"
      fill="#6B6C7B"
      stroke="white"
      strokeWidth="0.2"
    />
    <path
      d="M11.0008 9.58242C11.0169 9.87504 11.1184 10.1565 11.2928 10.3921C11.4672 10.6277 11.7068 10.8071 11.9821 10.9081C12.2573 11.0091 12.5561 11.0273 12.8416 10.9605C13.1271 10.8936 13.3867 10.7446 13.5884 10.5319C13.7901 10.3192 13.9251 10.0521 13.9766 9.76364C14.0282 9.47514 13.994 9.17787 13.8784 8.90854C13.7628 8.63922 13.5708 8.40965 13.3261 8.24819C13.0814 8.08672 12.7947 8.00044 12.5015 8C12.2987 8.00425 12.0987 8.0487 11.9132 8.13075C11.7276 8.2128 11.5602 8.33084 11.4206 8.47802C11.281 8.6252 11.1721 8.7986 11.1 8.98817C11.0279 9.17775 10.9942 9.37973 11.0008 9.58242Z"
      fill="#6B6C7B"
    />
    <path
      d="M10.7672 12.3785C10.5362 12.4859 10.3407 12.6598 10.2045 12.8789C10.0683 13.0981 9.99729 13.353 10.0001 13.6128C10.0001 13.9564 10.0001 13.9844 10.3357 13.9915H14.6507C14.7808 13.9915 15 14.0476 15 13.8722V13.6057C15.002 13.348 14.9314 13.0951 14.7965 12.8774C14.6617 12.6597 14.4683 12.4864 14.2397 12.3785C13.6945 12.129 13.104 12 12.5069 12C11.9097 12 11.3192 12.129 10.774 12.3785H10.7672Z"
      fill="#6B6C7B"
    />
  </svg>
);

Pan.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default Pan;
